import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
// import moment from "moment";
import { toast } from "react-toastify";
import { BodyBuilder } from "../../../../exports/Images";
import BorderedButton from "../../../payouts-wtf/common/BorderedButton";
import { changeTrainerShiftTimings } from "../../../../redux/reducers/postApiSlice";

const ManageTrainerShifts = ({
  decryptedText,
  trainerInfo,
  initialAction,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const initialTimeInputs = {
    morStartTime: "",
    morEndTime: "",
    evnStartTime: "",
    evnEndTime: "",
  };
  const [timeInputs, setTimeInputs] = useState(initialTimeInputs);
  const [isAPICall, setIsAPICall] = useState(false);

  const isEveningTime = (time) => {
    const eveningLimitHour = 12;
    const timeHour = parseInt(time.split(":")[0], 10);

    return timeHour >= eveningLimitHour;
  };

  const onChangeTimeInputs = (event) => {
    setIsAPICall(false);
    const { name, value } = event.target;
    setTimeInputs((prevInputs) => ({
      ...prevInputs,
      [name]: value,
    }));
  };

  const handleSubmit = async (userData, TOKEN) => {
    setIsAPICall(false);

    try {
      const actionResult = dispatch(
        changeTrainerShiftTimings({ userData, TOKEN })
      );
      const result = await actionResult;

      if (result.payload.status) {
        toast.success(result.payload?.message || "Success!");
        initialAction();
        setTimeInputs(initialTimeInputs);
        callFunction();
      } else {
        const errorMessage = result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.log("changeTrainerShiftTimings ERROR => ", error);
    }
  };

  const onSubmitShifts = (e) => {
    e.preventDefault();

    const { morStartTime, morEndTime, evnStartTime, evnEndTime } = timeInputs;

    if (
      (morStartTime && isEveningTime(morStartTime)) ||
      (morEndTime && isEveningTime(morEndTime)) ||
      (evnStartTime && !isEveningTime(evnStartTime)) ||
      (evnEndTime && !isEveningTime(evnEndTime))
    ) {
      setIsAPICall(false);
      toast.error("Invalid time selection");
      return;
    } else if (!trainerInfo?.userId) {
      setIsAPICall(false);
      toast.error("User ID not found!");
      return;
    } else {
      setIsAPICall(true);
    }
  };

  useEffect(() => {
    if (trainerInfo.actionData?.shift_details) {
      const morningShift = trainerInfo.actionData?.shift_details.find(
        (shift) => shift.shift_name === "Morning"
      );
      const eveningShift = trainerInfo.actionData?.shift_details.find(
        (shift) => shift.shift_name === "Evening"
      );

      if (morningShift) {
        setTimeInputs((prevInputs) => ({
          ...prevInputs,
          morStartTime: morningShift.start_time,
          morEndTime: morningShift.end_time,
        }));
      }

      if (eveningShift) {
        setTimeInputs((prevInputs) => ({
          ...prevInputs,
          evnStartTime: eveningShift.start_time,
          evnEndTime: eveningShift.end_time,
        }));
      }
    }
  }, [trainerInfo.actionData]);

  useEffect(() => {
    if (isAPICall) {
      const userData = {
        trainer_id: trainerInfo.userId,
        is_notify_owner: 0,
        shift_details: [
          {
            shift_name: "Morning",
            start_time: timeInputs.morStartTime,
            end_time: timeInputs.morEndTime,
            status: "active",
          },
          {
            shift_name: "Evening",
            start_time: timeInputs.evnStartTime,
            end_time: timeInputs.evnEndTime,
            status: "active",
          },
        ],
      };

      handleSubmit(userData, decryptedText?.token);
    }
  }, [isAPICall]);

  return (
    <>
      <div className="manageShiftContainer">
        {/* <ToastContainer /> */}

        <div className="infoContainer">
          <div className="imgContainer">
            <img
              src={BodyBuilder}
              alt={trainerInfo?.actionData?.name || "NA"}
            />
          </div>
          <div className="informationContainer">
            <p className="name">{trainerInfo?.actionData?.name || "NA"}</p>
            <span className="detail">Trainer</span>
          </div>
        </div>

        <form className="shiftDetailContainer">
          <div className="shiftBox">
            <p className="shiftTag">Morning Shift</p>

            <div className="shiftInputContainer">
              <div className="inputBox">
                <label htmlFor="mor-start-time" className="absoluteLabel">
                  Enter Start time
                </label>

                <div className="input-group time hoddedInput">
                  <input
                    type="time"
                    className="form-control"
                    placeholder="HH:MM AM/PM"
                    name="morStartTime"
                    value={timeInputs.morStartTime}
                    onChange={onChangeTimeInputs}
                  />
                </div>
              </div>

              <div className="inputBox">
                <label htmlFor="mor-end-time" className="absoluteLabel">
                  Enter end time
                </label>

                <div className="input-group time hoddedInput">
                  <input
                    type="time"
                    className="form-control"
                    placeholder="HH:MM AM/PM"
                    name="morEndTime"
                    value={timeInputs.morEndTime}
                    onChange={onChangeTimeInputs}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="shiftBox">
            <p className="shiftTag">Evening Shift</p>

            <div className="shiftInputContainer">
              <div className="inputBox">
                <label htmlFor="evn-start-time" className="absoluteLabel">
                  Enter Start time
                </label>

                <div className="input-group time hoddedInput">
                  <input
                    type="time"
                    className="form-control"
                    placeholder="HH:MM AM/PM"
                    name="evnStartTime"
                    value={timeInputs.evnStartTime}
                    onChange={onChangeTimeInputs}
                  />
                </div>
              </div>

              <div className="inputBox">
                <label htmlFor="evn-end-time" className="absoluteLabel">
                  Enter end time
                </label>

                <div className="input-group time hoddedInput">
                  <input
                    type="time"
                    className="form-control"
                    placeholder="HH:MM AM/PM"
                    name="evnEndTime"
                    value={timeInputs.evnEndTime}
                    onChange={onChangeTimeInputs}
                  />
                </div>
              </div>
            </div>
          </div>
        </form>

        <div className="buttonContainer lastFlex padded">
          <BorderedButton
            buttonText="Submit"
            onClickButton={onSubmitShifts}
            isDisabled={false}
          />
        </div>
      </div>
    </>
  );
};

export default ManageTrainerShifts;
